module.exports = __webpack_public_path__ + "static/img/sentrykit-2-wordmark.689eac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sentrykit-2-wordmark.png
// module id = 627
// module chunks = 2